declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, SaveOocyteQualityAssessmentRequest, SaveSingleWellFollicleRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, OqaDetails, OocyteAbnormalitiesDetails } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { OocytePipe, OocyteAbPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { Observable } from 'rxjs';
import { NgbEditOqaModal } from './editoqa.modal';
import { NgbEditAbnormalOqaModal } from './editabnormaloqa.modal';
import { NgbAddOqaModal } from './addoqa.modal';
import { NgbAddAbnormalOqaModal } from './addabnormaloqa.modal';
import { NgbSearchProviderModal } from './searchprovider.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ivfoqaedit',
  templateUrl: './ivfoqaedit.component.html',
  styleUrls: ['./ivfoqaedit.component.scss'],
  animations: [routerTransition()]
})

export class IvfOQAeditComponent implements OnInit, AfterViewInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;
  CurrentSaveSingleWellFollicleRequest: SaveSingleWellFollicleRequest;
  CurrentSaveOocyteMaturityInfoRequest: SaveOocyteMaturityInfoRequest;
  CurrentSaveOocyteMorphologyInfoRequest: SaveOocyteMorphologyInfoRequest;
  CurrentSaveIvfOocyteEmbryoStorageRequest: SaveIvfOocyteEmbryoStorageRequest;
  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;
  CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;
  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public Showoqa: boolean = true;
  public Showivf: boolean = false;
  public ProvidedName: string;
  public ProvidedCode: number;
  public ProvidedNumber: number;
  public ProvidedName2: string;
  public ProvidedCode2: number;
  public ProvidedNumber2: number;
  public Displaynew: boolean = false;
  public Displayold: boolean = true;
  TodayDate = new Date();
  //SelectedFromDate: NgbDateStruct;
  //


  CurrentFdActorReportsDocController: FdActorReportsDocController[];
  CurrentFDActorDocRequest: FDActorDocRequest;

  LoadForms() {
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFdActorReportsDocController();
  }
  public SelectedReport: string;
  public SelectedActorCode: number = 92;
  GetFdActorReportsDocController() {
    this.StartRefreshing();

    this.CurrentFDActorDocRequest.ActorCode = 92;
    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentFDActorDocRequest.ConditionalOperator = 11;
    //alert(this.FormattedCode);
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
      this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    public printService: PrintService, private spinner: NgxSpinnerService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private parserFormatter: NgbDateParserFormatter, private actorservice: ActorService, private hcpservice: HCPService, private filter: OocytePipe, private filter2: OocyteAbPipe, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    // this.LoadForms();
    this.LoadPatients();
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;
    this.CurrentSaveSingleWellFollicleRequest = new SaveSingleWellFollicleRequest();

    this.CurrentSaveSingleWellFollicleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveOocyteMaturityInfoRequest = new SaveOocyteMaturityInfoRequest();

    this.CurrentSaveOocyteMaturityInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveOocyteMorphologyInfoRequest = new SaveOocyteMorphologyInfoRequest();
    this.CurrentSaveOocyteMorphologyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest = new SaveIvfOocyteEmbryoStorageRequest();
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveCycleStatusRequest = new SaveCycleStatusRequest();

    this.CurrentSaveCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.onSetFeatureAccessConfig();

    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }


  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }
  dataChanged(newobj) {

    this._GetCycleOocyteQualityBetweenDateController();
  }
  _GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();
    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));

    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetCycleOocyteQualityBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetCycleOocyteQualityBetweenDateController();
    //ind++;
  }
  //var PatientActorCode = this.ActorCode;


  //AddDetails() {
  //  const modalRef = this.modalService.open(NgbTcDetailsModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  //AddEventDetails() {
  //  const modalRef = this.modalService.open(NgbEventAddModal,
  //    {
  //      centered: true

  //    })

  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentCycleOocyteQualityBetweenDateController,
          this.listFilter);
      }
    }
  }
  //

  //

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InsuminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
  OocyteQADetails: OocyteQualityAssessmentByCodeController;
  SelectedpatientDetails: CycleOocyteQualityBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: CycleOocyteQualityBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.LoadScansData();
      this.LoadOqaData();
      this.LoadMaturityData();
      this.LoadMorphologyData();
      this.LoadActorCode();
      this.LoadMaturityData2();
      //this.LoadTestData();
      //this.LoadMedicineData();
    }

  }
  CurrentOocyteQualityAssessmentByCodeController: //Observable<OocyteQualityAssessmentByCodeController>;
    Array<OocyteQualityAssessmentByCodeController>;
  FollicularOocyteInfo: OocyteQualityAssessmentByCodeController;
  CurrentOocyteQualityAssessmentByCodeRequest: OocyteQualityAssessmentByCodeRequest;

  LoadScansData() {
    //alert("ScansData")
    this.CurrentOocyteQualityAssessmentByCodeRequest = new OocyteQualityAssessmentByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentOocyteQualityAssessmentByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteQualityAssessmentByCodeController();
  }

  AddRow() {
    if (this.CurrentOocyteQualityAssessmentByCodeController == null) {
      this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
    }
    if (this.CurrentOocyteQualityAssessmentByCodeController != null) {

      var row = new OocyteQualityAssessmentByCodeController();
      row.WellNo = this.CurrentOocyteQualityAssessmentByCodeController.length + 1;
      row.GroupId = "";
      row.EmbryoId = "";
      row.SingleWellFollicleCoder = 0;
      this.CurrentOocyteQualityAssessmentByCodeController.push(row);
      this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');
      //this.CurrentOocyteQualityAssessmentByCodeController.po
    }

  }
  GetOocyteQualityAssessmentByCodeController() {
    // this.StartRefreshing();

    this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentOocyteQualityAssessmentByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetOocyteQualityAssessmentByCodeController(this.CurrentOocyteQualityAssessmentByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentOocyteQualityAssessmentByCodeController = this.ApiResData.Result;
          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfOocyteEmbryoStorageByCodeController: Array<IvfOocyteEmbryoStorageByCodeController>;
  CurrentIvfOocyteEmbryoStorageByCodeRequest: IvfOocyteEmbryoStorageByCodeRequest;

  LoadOqaData() {
    //alert("ScansData")
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest = new IvfOocyteEmbryoStorageByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfOocyteEmbryoStorageByCodeController();
  }

  GetIvfOocyteEmbryoStorageByCodeController() {
    //this.StartRefreshing();

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;

    this.CurrentIvfOocyteEmbryoStorageByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfOocyteEmbryoStorageByCodeController(this.CurrentIvfOocyteEmbryoStorageByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfOocyteEmbryoStorageByCodeController = this.ApiResData.Result;

          if (this.CurrentIvfOocyteEmbryoStorageByCodeController != null ||
            this.CurrentIvfOocyteEmbryoStorageByCodeController.length > 0) {

            this.OocyteStoreItems = new Array<OocyteStoreItem>();
            this.CurrentIvfOocyteEmbryoStorageByCodeController.forEach((v, i, d) => {
              var item = new OocyteStoreItem();
              item.IsSelected = false;
              item.Morphology = v.Morphology;
              item.OocyteEmbryoStorageCode = v.OocyteEmbryoStorageCode;
              item.Status = v.Status;
              item.StorageUnitType = v.StorageUnitType;
              item.StorageUnitDetails = v.StorageUnitDetails;
              item.WellNo = v.WellNo;
              this.OocyteStoreItems.push(item);
            });

          }

          //this.OocyteQADetails = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          this.LoadCycles();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  OocyteStoreItems: Array<OocyteStoreItem>;
  Store() {
    //alert(new);
    var toFreeze = this.CurrentOocyteQualityAssessmentByCodeController.filter(function (v, i, d) {
      return v.IsFrozen == true
    });

    if (this.CurrentIvfOocyteEmbryoStorageByCodeController == null ||
      this.CurrentIvfOocyteEmbryoStorageByCodeController.length == 0) {

      this.OocyteStoreItems = new Array<OocyteStoreItem>();
      toFreeze.forEach((v, i, d) => {
        var item = new OocyteStoreItem();
        item.IsSelected = false;
        item.Morphology = v.Morphology;
        item.OocyteEmbryoStorageCode = 0;
        item.WellNo = v.WellNo;
        this.OocyteStoreItems.push(item);
      });

    }
  }


  onSubmit2(data2: OocyteStoreItem) {


    if (data2.OocyteEmbryoStorageCode == 0) {
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
    }
    else {
      this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 20;
    }
    //  this.CurrentSaveIvfOocyteEmbryoStorageRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.ItemType = "OOCYTE";
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateDate = new Date();
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.LastUpdateTime = new Date();
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.Morphology = data2.Morphology;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.OocyteEmbryoStorageCode = data2.OocyteEmbryoStorageCode;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.Status = "FROZEN";
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitDetails = data2.StorageUnitDetails;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.StorageUnitType = data2.StorageUnitType;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfOocyteEmbryoStorageRequest.Grade = "";

    this.CurrentSaveIvfOocyteEmbryoStorageRequest.WellNo = data2.WellNo;


    this.actorservice.SaveIvfOocyteEmbryoStorage(this.CurrentSaveIvfOocyteEmbryoStorageRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            //this.LoadInsemination();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  onSubmit(data: OocyteQualityAssessmentByCodeController) {

    this.CurrentSaveSingleWellFollicleRequest.WellNo = data.WellNo;
    this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPost = data.OocyteQualityPost;
    this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPre = data.OocyteQualityPre;
    this.CurrentSaveSingleWellFollicleRequest.IsFrozen = data.IsFrozen;
    this.CurrentSaveSingleWellFollicleRequest.IsDiscarded = data.IsDiscarded;
    this.CurrentSaveSingleWellFollicleRequest.Morphology = data.Morphology;
    this.CurrentSaveSingleWellFollicleRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveSingleWellFollicleRequest.SingleWellFollicleCode = data.SingleWellFollicleCoder;
    this.CurrentSaveSingleWellFollicleRequest.GroupId = data.GroupId;
    this.CurrentSaveSingleWellFollicleRequest.EmbryoId = data.EmbryoId;

    if (data.SingleWellFollicleCoder == 0)
      this.CurrentSaveSingleWellFollicleRequest.ConditionalOperator = 1;
    else
      this.CurrentSaveSingleWellFollicleRequest.ConditionalOperator = 1;

    this.actorservice.SaveSingleWellFollicle(this.CurrentSaveSingleWellFollicleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  delwell(l: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentitiesWell(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentitiesWell(l: any) {
    var item2 = l as OocyteQualityAssessmentByCodeController;

    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveSingleWellFollicleRequest.ConditionalOperator = 3;

    this.CurrentSaveSingleWellFollicleRequest.WellNo = item2.WellNo;
    this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPost = item2.OocyteQualityPost;
    this.CurrentSaveSingleWellFollicleRequest.OocyteQualityPre = item2.OocyteQualityPre;
    this.CurrentSaveSingleWellFollicleRequest.IsFrozen = item2.IsFrozen;
    this.CurrentSaveSingleWellFollicleRequest.IsDiscarded = item2.IsDiscarded;
    this.CurrentSaveSingleWellFollicleRequest.Morphology = item2.Morphology;
    this.CurrentSaveSingleWellFollicleRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveSingleWellFollicleRequest.SingleWellFollicleCode = item2.SingleWellFollicleCoder;

    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveSingleWellFollicle(this.CurrentSaveSingleWellFollicleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.ShowList = true;
            this.LoadScansData();

            //  this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  Assessment() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.IsAssessmentCompeted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  IsAssessmentCompeted() {


    console.log('..................');
    // this.StartRefreshing();
    this.CurrentSaveCycleStatusRequest.ConditionalOperator = 30;

    this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveCycleStatusRequest.ActivityName = "Oocyte Assessment";
    this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
    this.CurrentSaveCycleStatusRequest.Remarks = "None";
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  OocyteData: TreatmentCycleStatusController[];
  OocyteData2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.OocyteData = this.ApiResData.Result;
          var Oocytelist = this.OocyteData.filter(
            function (e) {
              return e.PhaseActivity == "Oocyte Assessment";
            });
          this.OocyteData = Oocytelist;
          this.OocyteData2 = this.OocyteData[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadActorCode() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];

          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorCodeDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.ActorCodeDetails.OwnerActorCode;
      return OwnerActorCode;
    }
  }
  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  CurrentOocyteMaturityByCycleController: OocyteMaturityByCycleController[];
  //DenudationInfo: OocyteMaturityByCycleController;
  CurrentOocyteMaturityByCycleRequest: OocyteMaturityByCycleRequest;

  LoadMaturityData() {
    //alert("ScansData")
    this.CurrentOocyteMaturityByCycleRequest = new OocyteMaturityByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentOocyteMaturityByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteMaturityByCycleController();
  }
  //AddRowMaturity() {
  //  if (this.CurrentOocyteMaturityByCycleController == null) {
  //    this.CurrentOocyteMaturityByCycleController = new Array<OocyteMaturityByCycleController>();
  //  }
  //  if (this.CurrentOocyteMaturityByCycleController != null) {

  //    var row = new OocyteMaturityByCycleController();

  //    row.MaturityLevel = "";
  //    row.OccCount = 0;
  //    row.DenudedCount = 0;
  //    this.CurrentOocyteMaturityByCycleController.push(row);
  //    this.tosterservice.ToasterSuccessAlertParam('New Row Added Successfully.....!');

  //  }

  //}
  GetOocyteMaturityByCycleController() {

    this.CurrentOocyteMaturityByCycleRequest.ConditionalOperator = 10;
    this.CurrentOocyteMaturityByCycleRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;


    this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentOocyteMaturityByCycleController = this.ApiResData.Result;
          //this.DenudationInfo = this.CurrentOocyteMaturityByCycleController[0];

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentOocyteMaturityByCycleController2: OocyteMaturityByCycleController[];
  DenudationInfo: OocyteMaturityByCycleController;
  CurrentOocyteMaturityByCycleRequest2: OocyteMaturityByCycleRequest;

  LoadMaturityData2() {
    //alert("ScansData")
    this.CurrentOocyteMaturityByCycleRequest2 = new OocyteMaturityByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentOocyteMaturityByCycleRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteMaturityByCycleController2();
  }

  GetOocyteMaturityByCycleController2() {

    this.CurrentOocyteMaturityByCycleRequest2.ConditionalOperator = 15;
    this.CurrentOocyteMaturityByCycleRequest2.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;


    this.actorservice.GetOocyteMaturityByCycleController(this.CurrentOocyteMaturityByCycleRequest2)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentOocyteMaturityByCycleController2 = this.ApiResData.Result;
          this.DenudationInfo = this.CurrentOocyteMaturityByCycleController2[0];

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentOocyteMorphologyByCycleController: OocyteMorphologyByCycleController[];
  CurrentOocyteMorphologyByCycleRequest: OocyteMorphologyByCycleRequest;

  LoadMorphologyData() {
    //alert("ScansData")
    this.CurrentOocyteMorphologyByCycleRequest = new OocyteMorphologyByCycleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentOocyteMorphologyByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteMorphologyByCycleController();
  }

  GetOocyteMorphologyByCycleController() {
    // this.StartRefreshing();
    this.CurrentOocyteMorphologyByCycleRequest.ConditionalOperator = 10;
    this.CurrentOocyteMorphologyByCycleRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;

    //alert(this.FormattedCode);
    this.actorservice.GetOocyteMorphologyByCycleController(this.CurrentOocyteMorphologyByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentOocyteMorphologyByCycleController = this.ApiResData.Result;

          this.pdata2 = this.CurrentOocyteMorphologyByCycleController;
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  AddOqa() {
    const modalRef = this.modalService.open(NgbAddOqaModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;

    modalRef.result.then(x => { this.GetOocyteMaturityByCycleController() })
  }
  EditOqa(l: OocyteMaturityByCycleController) {
    this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
    this.CurrentSaveOocyteMaturityInfoRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveOocyteMaturityInfoRequest.DenudedCount = l.DenudedCount;
    this.CurrentSaveOocyteMaturityInfoRequest.MaturityLevel = l.MaturityLevel;
    this.CurrentSaveOocyteMaturityInfoRequest.OccCount = l.OccCount;
    this.CurrentSaveOocyteMaturityInfoRequest.CycleOocyteQualityCode = l.OocyteQualityCode;
    const modalRef = this.modalService.open(NgbEditOqaModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CurrentSaveOocyteMaturityInfoRequest = this.CurrentSaveOocyteMaturityInfoRequest;
    modalRef.result.then(x => { this.GetOocyteMaturityByCycleController() })
  }
  OnSubmitOqanew() {
    this.spinner.show();
    // this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.DenudationInfo.DenudationBy;
    //this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
    this.CurrentSaveOocyteMaturityInfoRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveOocyteMaturityInfoRequest.OqaData = new Array<OqaDetails>();
    this.CurrentOocyteMaturityByCycleController.forEach((v, i, a) => {
      var item: OqaDetails = new OqaDetails();
      item.CycleOocyteQualityCode = v.OocyteQualityCode;
      item.DenudedCount = v.DenudedCount;
      item.MaturityLevel = v.MaturityLevel;
      item.OccCount = v.OccCount;
      this.CurrentSaveOocyteMaturityInfoRequest.OqaData.push(item);
    });
    //this.CurrentSaveOocyteMaturityInfoRequest.RecordStatus = this.DenudationInfo.;

    this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
    this.actorservice.SaveOocyteMaturityInfo(this.CurrentSaveOocyteMaturityInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.LoadMaturityData();
            //this.isvisibleendo = true;
            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );
  }
  OnSubmitOqaanormailites() {
    this.spinner.show();
    // this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.DenudationInfo.DenudationBy;
    //this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 20;
    this.CurrentSaveOocyteMorphologyInfoRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveOocyteMorphologyInfoRequest.OocyteAbnormalitiesData = new Array<OocyteAbnormalitiesDetails>();
    this.CurrentOocyteMorphologyByCycleController.forEach((v, i, a) => {
      var itemab: OocyteAbnormalitiesDetails = new OocyteAbnormalitiesDetails();
      itemab.CycleOocyteMorphologyCode = v.OocyteMorphologyCode;
      itemab.Morphology = v.Morphology;
      itemab.OocyteCount = v.OocyteCount;
      //item.OccCount = v.OccCount;
      this.CurrentSaveOocyteMorphologyInfoRequest.OocyteAbnormalitiesData.push(itemab);
    });
    //this.CurrentSaveOocyteMaturityInfoRequest.RecordStatus = this.DenudationInfo.;

    this.CurrentSaveOocyteMorphologyInfoRequest.ConditionalOperator = 20;
    this.actorservice.SaveOocyteMorphologyInfo(this.CurrentSaveOocyteMorphologyInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.LoadMorphologyData();
            //this.isvisibleendo = true;
            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );
  } AddAbnormalOqa() {
    const modalRef = this.modalService.open(NgbAddAbnormalOqaModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    modalRef.result.then(x => { this.GetOocyteMorphologyByCycleController() })
  }
  EditAbnormalOqa(datanormal: OocyteMorphologyByCycleController) {
    this.CurrentSaveOocyteMorphologyInfoRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveOocyteMorphologyInfoRequest.Morphology = datanormal.Morphology;
    this.CurrentSaveOocyteMorphologyInfoRequest.OocyteCount = datanormal.OocyteCount;
    this.CurrentSaveOocyteMorphologyInfoRequest.CycleOocyteMorphologyCode = datanormal.OocyteMorphologyCode;
    this.CurrentSaveOocyteMorphologyInfoRequest.ConditionalOperator = 20;
    const modalRef = this.modalService.open(NgbEditAbnormalOqaModal,
      {
        centered: true,
        keyboard: false,
        backdrop: 'static'

      })
    modalRef.componentInstance.CurrentSaveOocyteMorphologyInfoRequest = this.CurrentSaveOocyteMorphologyInfoRequest;
    modalRef.result.then(x => { this.GetOocyteMorphologyByCycleController() })
  }
  ProvidedSelection() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowProvieded = true;
      modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProvidedName = receivedEntry.make;
      this.ProvidedCode = receivedEntry.value;
      this.ProvidedNumber = receivedEntry.number;
      //alert(this.ProvidedName);
    })
  }
  ProvidedSelection2() {
    this.Displaynew = true;
    this.Displayold = false;
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProvidedName2 = receivedEntry.make;
      this.ProvidedCode2 = receivedEntry.value;
      this.ProvidedNumber2 = receivedEntry.number;
      //this.CurrentSaveOocyteMaturityInfoRequest.PrescribedBy = this.ProviderCode2;
      //this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.ProvidedName2;

      //alert(this.ProviderName);
    })
  }
  onSubmit3() {
    //this.isvisibleendo = false;
    this.spinner.show();
    // this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = this.DenudationInfo.DenudationBy;
    this.CurrentSaveOocyteMaturityInfoRequest.CycleCode = this.DenudationInfo.TreatmentCycle;
    this.CurrentSaveOocyteMaturityInfoRequest.CycleOocyteQualityCode = this.DenudationInfo.OocyteQualityCode;
    this.CurrentSaveOocyteMaturityInfoRequest.MaturityLevel = this.DenudationInfo.MaturityLevel;
    this.CurrentSaveOocyteMaturityInfoRequest.OccCount = this.DenudationInfo.OccCount;
    this.CurrentSaveOocyteMaturityInfoRequest.DenudedCount = this.DenudationInfo.DenudedCount;
    this.CurrentSaveOocyteMaturityInfoRequest.DenudedByActor = this.DenudationInfo.DenudedByActor;
    //this.CurrentSaveOocyteMaturityInfoRequest.RecordStatus = this.DenudationInfo.;

    this.CurrentSaveOocyteMaturityInfoRequest.ConditionalOperator = 15;
    this.actorservice.SaveOocyteMaturityInfo(this.CurrentSaveOocyteMaturityInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.isvisibleendo = true;
            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            this.spinner.hide();
          }
        }
      );


  }
  onAssignedToActorCodesurgeon(event: any) {

    //alert(event);
    if (event != null) {

      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      // this.CurrentSaveOocyteMaturityInfoRequest.DenudedByActor = event;
      this.CurrentSaveOocyteMaturityInfoRequest.DenudationBy = event;

      // console.log('event--_>' + event);
      //   }
    }

  }
  pdata2: any[];// = this.data;
  listFilter2: string;
  ngOnChanges2(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata2 = this.CurrentOocyteMorphologyByCycleController;

    this.criteriaChange2(this.listFilter2);
  }
  criteriaChange2(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter2 = value;
        //alert(this.listFilter);
        this.pdata2 = this.filter2.transform(this.CurrentOocyteMorphologyByCycleController,
          this.listFilter2);
      }
    }
  }

  //Selectedpatient() {
  //  this.ScanDetails = true;
  //}
  BackTodashboard() {
    //this.Showivf = true;
    //this.Showoqa = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  printoocyte() {
    this.printService.printDocument("oocytequality",
      {
        OQACodedata: this.SelectedpatientDetails.OocyteQualityCode, Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate, Sign1Name: this.SelectedpatientDetails.Sign1Name,
      }
    );
  }
  printoocytedroplet() {
    this.printService.printDocument2(this.SelectedpatientDetails.OwnerFormattedCode, 0

    );
    this.printService.printDocument("oocytequalitydroplet",
      {
        OQACodedata: this.SelectedpatientDetails.OocyteQualityCode, Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        EggSourceData: this.ActorCodeDetails.EggSourceType, DonorData: this.ActorCodeDetails.EggName, DonorCode: this.ActorCodeDetails.EggFormattedCode, TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, ActorCodedata: this.SelectedpatientDetails.EggSourceActorCode, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate, Sign1Name: this.SelectedpatientDetails.Sign1Name,
      }
    );
  }
}
export class OocyteStoreItem {

  public OocyteEmbryoStorageCode: number;

  public WellNo: number;
  public StorageUnitType: string;
  public StorageUnitDetails: string;
  public Status: string;

  public Morphology: string;

  public IsSelected: boolean;
}
